import { type FC } from "react"
import styled, { css } from "styled-components"

import { type RecentEvent } from "@forento/core/models/dashboard"

import PartialLoadingPage from "~/components/PartialLoadingPage"
import { cardColor, componentBackgroundColor } from "~/utilities/styles"

import Event from "./Event"

type Placement = "aside" | "inline"

type Props = {
	data: { status: "error" | "loading" } | { status: "success"; events: RecentEvent[] }
	placement?: Placement
}
const AsideContent: FC<Props> = ({ data, placement = "aside" }) => (
	<Container $placement={placement}>
		<Title $placement={placement}>Recent events</Title>
		{data.status === "success" ? (
			<Section $placement={placement}>
				{data.events.map((event, index) => (
					<Event key={index} event={event} />
				))}
			</Section>
		) : data.status === "loading" ? (
			<PartialLoadingPage />
		) : null}
	</Container>
)

const Container = styled.div<{ $placement: Placement }>`
	${props =>
		props.$placement === "aside"
			? css`
					flex: 0.5 0 0;
					background-color: ${componentBackgroundColor};
					padding: 34px 24px;

					@media (max-width: 1279px) {
						display: none;
					}
				`
			: css`
					display: flex;
					flex-direction: column;
					gap: 16px;
					background-color: ${cardColor.gray};
					border-radius: 24px;
					padding: 16px;

					@media (min-width: 1280px) {
						display: none;
					}
				`}

	@media (max-width: 640px) {
		padding: 16px;
	}
`

const Title = styled.h2<{ $placement: Placement }>`
	font-weight: 600;
	font-size: ${props => (props.$placement === "aside" ? "32px" : "16px")};
	line-height: 1.2;
	margin-bottom: ${props => (props.$placement === "aside" ? "20px" : "0")};

	@media (max-width: 640px) {
		font-size: ${props => (props.$placement === "aside" ? "24px" : "16px")};
	}
`

const Section = styled.div<{ $placement: Placement }>`
	background-color: white;
	border-radius: ${props => (props.$placement === "aside" ? "24px" : "16px")};
	max-width: ${props => (props.$placement === "aside" ? "600px" : "none")};
	overflow: hidden;
`

export default AsideContent
